var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{key:Math.random(),staticClass:"icon",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{class:_vm.iconClass,attrs:{"data-fa-mask":_vm.maskClass,"data-fa-transform":_vm.transform}})])
}
var staticRenderFns = []

export { render, staticRenderFns }